import React, { useState } from 'react';
import { Share2, Copy, Check } from 'lucide-react';
import { NgapAct } from '../types/ngap';
import { shareByEmail, shareOnTwitter, shareOnLinkedIn, shareOnFacebook, copyShareLink } from '../utils/shareUtils';
import { trackShareLinkCopied } from '../utils/analyticsEvents';

interface ShareButtonProps {
  act: NgapAct;
  darkMode: boolean;
}

const ShareButton: React.FC<ShareButtonProps> = ({ act, darkMode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    const success = await copyShareLink(act);
    if (success) {
      setCopied(true);
      trackShareLinkCopied(window.location.pathname);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleShare = (shareFunction: () => void) => {
    shareFunction();
    setIsOpen(false);
  };

  const itemClass = `w-full flex items-center px-3 py-2 text-sm rounded-md transition-colors ${
    darkMode
      ? 'text-appines-white/65 hover:bg-appines-white/10 hover:text-appines-white'
      : 'text-appines-petrol/65 hover:bg-[rgba(1,42,54,0.06)] hover:text-appines-petrol'
  }`;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`p-2 rounded-lg transition-colors ${
          darkMode
            ? 'text-appines-white/45 hover:text-appines-white hover:bg-appines-white/10'
            : 'text-appines-petrol/45 hover:text-appines-petrol hover:bg-[rgba(1,42,54,0.06)]'
        }`}
        aria-label="Partager cet acte"
      >
        <Share2 className="h-5 w-5" />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          
          <div className={`absolute top-full right-0 mt-2 w-48 rounded-lg shadow-lg border z-50 ${
            darkMode ? 'bg-appines-petrol border-appines-white/12' : 'bg-appines-white border-[rgba(1,42,54,0.12)]'
          }`}>
            <div className="p-2 space-y-1">
              <button onClick={handleCopyLink} className={itemClass}>
                {copied ? (
                  <>
                    <Check className="h-4 w-4 mr-2 text-appines-emerald" />
                    Copié !
                  </>
                ) : (
                  <>
                    <Copy className="h-4 w-4 mr-2" />
                    Copier le lien
                  </>
                )}
              </button>
              
              <button onClick={() => handleShare(() => shareByEmail(act))} className={itemClass}>
                <span className="mr-2">📧</span> Email
              </button>
              
              <button onClick={() => handleShare(() => shareOnTwitter(act))} className={itemClass}>
                <span className="mr-2">🐦</span> Twitter
              </button>
              
              <button onClick={() => handleShare(() => shareOnLinkedIn(act))} className={itemClass}>
                <span className="mr-2">💼</span> LinkedIn
              </button>
              
              <button onClick={() => handleShare(() => shareOnFacebook(act))} className={itemClass}>
                <span className="mr-2">📘</span> Facebook
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton;
